import React from 'react';
import {
  TextField,
  Box
} from '@mui/material';
import { PopupDialog } from '../../../../components/common';
import { useMarcaForm } from '../hooks/useMarcaForm';
import { useMarcaStore } from '../store';

interface Props {
  open: boolean;
  marcaId: number | null;
  onClose: () => void;
}

export const MarcaEditDialog: React.FC<Props> = ({
  open,
  marcaId,
  onClose
}) => {
  const { saveMarca } = useMarcaStore();

  const {
    formData,
    errors,
    loading,
    isValid,
    handleChange,
    handleSubmit,
    resetForm
  } = useMarcaForm(marcaId, saveMarca);

  const handleSave = async () => {
    try {
      await handleSubmit();
      onClose();
      resetForm();
    } catch {
      // Error handling is done in the hook and store
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
      resetForm();
    }
  };

  return (
    <PopupDialog
      open={open}
      onClose={handleClose}
      title={marcaId ? 'Editar Marca' : 'Nueva Marca'}
      maxWidth="sm"
      primaryAction={{
        label: loading ? 'Guardando...' : 'Guardar',
        onClick: handleSave,
        disabled: loading || !isValid,
        loading: loading
      }}
      secondaryAction={{
        label: 'Cancelar',
        onClick: handleClose,
        disabled: loading
      }}
    >
      <Box sx={{ pt: 1 }}>
        <TextField
          autoFocus
          fullWidth
          label="Descripción"
          name="descripcion"
          value={formData.descripcion}
          onChange={handleChange}
          error={!!errors.descripcion}
          helperText={errors.descripcion}
          disabled={loading}
        />
      </Box>
    </PopupDialog>
  );
};